import { FetchAPage } from "components/shared";

export const About = () => {
  return <FetchAPage name="about" />;
};
